import { render, staticRenderFns } from "./AdminServices.vue?vue&type=template&id=1d4a0200"
import script from "./AdminServices.vue?vue&type=script&lang=js"
export * from "./AdminServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports